module.exports = __webpack_public_path__ + "static/media/Close.fe0e7e13.svg";